import React from 'react';
import Hero from './Hero';
import { NewsSection } from './InfoSections';
import AboutSection from './AboutSection';
import SEO from './SEO';

const Home: React.FC = () => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "NexOverseas",
        "url": "https://www.nexoverseas.co.uk",
        "logo": "https://www.nexoverseas.co.uk/assets/logo.png",
        "sameAs": [
            "https://www.facebook.com/nexoverseas",
            "https://www.instagram.com/nexoverseas",
            "https://www.linkedin.com/company/nexoverseas"
        ],
        "description": "NexOverseas is the all-in-one operating system for your global career, providing expert guidance on admissions, visas, travel, and accommodation."
    };

    return (
        <>
            <SEO
                title="Home"
                description="The all-in-one operating system for your global career. Admissions, Coaching, Visa, Travel & Transport, and Advisory."
                canonical="/"
                structuredData={structuredData}
            />
            <Hero />
            <AboutSection />
            <NewsSection />
        </>
    );
};

export default Home;
